export const TOKEN_KEY = "accessToken" as string;

export const REFRESH_TOKEN_KEY = "refreshToken" as string;

const UID_KEY = "uid" as string;

/**
 * @description uid from localStorage
 */
export const getUid = (): string | null => {
  return window.localStorage.getItem(UID_KEY);
};

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(TOKEN_KEY);
};

/**
 * @description get refresh token form localStorage
 */
export const getRefreshToken = (): string | null => {
  return window.localStorage.getItem(REFRESH_TOKEN_KEY);
};

/**
 * @description save uid into localStorage
 * @param uid: string
 */
export const saveUid = (uid: string): void => {
  window.localStorage.setItem(UID_KEY, uid);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(TOKEN_KEY, token);
};

/**
 * @description save refresh token into localStorage
 * @param refreshToken: string
 */
export const saveRefreshToken = (refreshToken: string): void => {
  window.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

/**
 * @description remove uid, token and refresh token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(UID_KEY);
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(REFRESH_TOKEN_KEY);
};

export default {
  getUid,
  getToken,
  getRefreshToken,
  saveUid,
  saveToken,
  saveRefreshToken,
  destroyToken,
};
